<script>
	import CheeseTypes from "./CheeseTypes.svelte"
    import Locations from "./Locations.svelte";
</script>

<CheeseTypes />
<br /><br />
<Locations />
